import PropTypes from 'prop-types';
import React from 'react';
import PaymentInstalmentCard from '../cards/payment-instalment-card';

function InstalmentDetails({ instalments }) {
  // console.log(instalments, 'instalmet');
  return (
    <>
      <h2 className="text-[22px] font-bold mb-6">Payment Details</h2>
      {/* TODO DO NOT SHOW DO PAYMENT IF SHEDULED */}
      {instalments?.map((instalment, index) => (
        <PaymentInstalmentCard
          key={(instalment.planId + instalment.instalmentNo) ?? index}
          instalmentNo={index + 1}
          instalmentStatus={instalment.instalmentStatus}
          clearedAmount={instalment.totalPayable}
          instalmentId={instalment.instalmentId}
          dueDate={instalment.dueDate}
          dueFromDay={instalment.dueFromDay}
          paymentDoneOn={instalment.paymentDoneOn}
        />
      ))}
    </>
  );
}
InstalmentDetails.propTypes = {
  instalments: PropTypes.array.isRequired,
};
export default InstalmentDetails;
